import React from "react";
import Icon from "components/AppIcon";

const BlueprintHero = ({ formData }) => {
  const name = formData?.name || "Professional";
  const profession = formData?.profession || "your field";

  return (
    <div className="rounded-2xl p-6 md:p-8 lg:p-10 border relative overflow-hidden" style={{ background: "linear-gradient(135deg, rgba(40,59,163,0.06) 0%, rgba(211,172,53,0.06) 100%)", borderColor: "var(--color-border)" }}>
      <div className="absolute top-0 right-0 w-64 h-64 rounded-full opacity-5" style={{ background: "radial-gradient(circle, #283ba3 0%, transparent 70%)", transform: "translate(30%, -30%)" }} aria-hidden="true" />

      <div className="relative z-10 flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
        <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "var(--color-primary)" }}>
          <Icon name="FileText" size={28} color="#fff" strokeWidth={1.5} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs font-semibold uppercase tracking-widest px-2 py-0.5 rounded-full" style={{ backgroundColor: "rgba(211,172,53,0.15)", color: "var(--color-accent)", fontFamily: "var(--font-caption)" }}>Personalized Blueprint</span>
          </div>
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-1" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
            {name}&apos;s QuantuMe Prospectus AI Income Blueprint
          </h1>
          <p className="text-sm md:text-base" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-body)" }}>
            Tailored for your background in <span className="font-semibold" style={{ color: "var(--color-primary)" }}>{profession}</span> — a strategic roadmap to monetize your expertise in the AI-powered economy.
          </p>
        </div>
        <div className="flex flex-row md:flex-col gap-3 md:gap-2 flex-shrink-0">
          <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-amber-300 border-amber-400" style={{ backgroundColor: "rgba(40,59,163,0.05)", border: "1px solid rgba(40,59,163,0.15)" }}>
            <Icon name="CheckCircle" size={14} color="var(--color-success)" strokeWidth={2} />
            <span className="text-xs font-medium whitespace-nowrap text-amber-50" style={{ color: "var(--color-success)", fontFamily: "var(--font-caption)" }}>6 Sections</span>
          </div>
          <div className="flex items-center gap-2 px-3 py-2 rounded-lg" style={{ backgroundColor: "rgba(40,59,163,0.06)", border: "1px solid rgba(40,59,163,0.15)" }}>
            <Icon name="Calendar" size={14} color="var(--color-primary)" strokeWidth={2} />
            <span className="text-xs font-medium whitespace-nowrap" style={{ color: "var(--color-primary)", fontFamily: "var(--font-caption)" }}>30-Day Plan</span>
          </div>
        </div>
      </div>
    </div>);

};

export default BlueprintHero;